import 'react-app-polyfill/ie9';
import 'core-js/modules/es6.symbol';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'raf/polyfill';
import 'core-js/es6/string';
import "core-js/es7/array";
import "core-js/es7/object";
import "core-js/es7/string";
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import {
  BrowserRouter as Router,
} from 'react-router-dom'
import './styles/App.css'

ReactDOM.render((

  <Router forceRefresh>

    <App />

  </Router>
), document.getElementById('root'))

//registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js